"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETipoDispensa = void 0;
var ETipoDispensa;
(function (ETipoDispensa) {
    ETipoDispensa["Optante"] = "P";
    ETipoDispensa["S"] = "S";
    ETipoDispensa["Dispensado"] = "D";
    ETipoDispensa["Dispensa por trabalho"] = "DT";
    ETipoDispensa["Dispensa por lei"] = "DL";
    ETipoDispensa["Dispensa m\u00E9dica"] = "DM";
    ETipoDispensa["N\u00E3o optante"] = "N";
    ETipoDispensa["Desistiu"] = "I";
})(ETipoDispensa = exports.ETipoDispensa || (exports.ETipoDispensa = {}));
